import * as tslib_1 from "tslib";
import React, { useState, useEffect } from 'react';
import styled from '@/shared/styled';
import { Tree, Card, Row, Col } from 'antd';
import { fetchGroupAll, fetchProjectAll, fetchProjectDoc, } from '@/services/helpLinks';
import { dispatch } from '@@/store';
import { setupHistoryLauncher } from '@souche-f2e/muji-plugin-history-launcher/lib/browser';
import { urlParams } from '@/shared/utils';
const { TreeNode, DirectoryTree } = Tree;
const Root = styled.div `
  height: 100%;
  .tree-card {
    .ant-tree {
      height: calc(100vh - 64px - 56px - 48px);
      overflow-y: auto;
      overflow-x: hidden;
    }
    li .ant-tree-node-content-wrapper {
      display: inline-block;
      width: calc(100% - 24px);
      .ant-tree-title {
        display: inline-block;
        width: 100%;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
    }
  }
  .card-iframe {
    height: calc(100vh - 64px);
    .ant-card-body {
      height: 100%;
    }
  }
`;
function formatDocData(list) {
    const res = [];
    const map = list.reduce((res, v) => ((res[v.id] = v), res), {});
    for (const item of list) {
        item.key = `${item.id}_${item.parentDirId}`;
        item.title = item.documentName;
        item.isLeaf = !item.children;
        if (item.parentDirId === null) {
            res.push(item);
            continue;
        }
        if (item.parentDirId in map) {
            const parent = map[item.parentDirId];
            parent.children = parent.children || [];
            parent.children.push(item);
        }
    }
    return res;
}
const HelpDoc = ({ className, style }) => {
    const [data, setData] = useState([]);
    const [iframeUrl, setIframeUrl] = useState('');
    useEffect(() => {
        setupHistoryLauncher();
        fetchBasicInfo();
    }, ['hot']);
    useEffect(() => {
        const url = urlParams(window.location.href, 'url');
        if (url) {
            setIframeUrl(url);
        }
    }, []);
    const fetchBasicInfo = () => tslib_1.__awaiter(this, void 0, void 0, function* () {
        const groupsP = fetchGroupAll().promise;
        const projectsP = fetchProjectAll().promise;
        const groups = yield groupsP;
        const projects = yield projectsP;
        const formatedGroupArray = groups.map((item) => {
            const ownProjects = projects.filter((project) => project.groupId === item.id);
            ownProjects.forEach((item) => {
                item.title = item.projectName;
                item.key = `${item.groupId}_${item.id}`;
            });
            if (ownProjects.length) {
                item.children = ownProjects;
            }
            else {
                item.isLeaf = true;
            }
            item.title = item.groupName;
            item.key = item.id.toString();
            return item;
        });
        setData(formatedGroupArray);
    });
    const onLoadData = (treeNode) => new Promise((resolve) => tslib_1.__awaiter(this, void 0, void 0, function* () {
        if (treeNode.props.children) {
            resolve();
            return;
        }
        const res = yield fetchProjectDoc(Number(treeNode.props.id)).promise;
        const formatedRes = formatDocData(res);
        treeNode.props.dataRef.children = formatedRes;
        setData([...data]);
        resolve();
    }));
    const handleOnSelect = (selectedKeys, e) => {
        const nodeInfo = e.node.props;
        // 异步动态获取子节点的节点，需等待接口返回数据后再判断
        if (!nodeInfo.loaded && !nodeInfo.isLeaf && !nodeInfo.children) {
            // 需异步获取自节点数据的节点
            setTimeout(() => {
                if (!e.node.props.children) {
                    setIframeUrl(nodeInfo.documentUrl);
                    dispatch.router.replace({
                        query: {
                            url: nodeInfo.documentUrl,
                        },
                    });
                    console.log('异步获取到数据后,无孩子节点，则用自己的');
                }
                else {
                    setIframeUrl('');
                    console.log('异步获取到数据后,有孩子节点');
                }
            }, 1000);
        }
        else if (!nodeInfo.children) {
            setIframeUrl(nodeInfo.documentUrl);
            dispatch.router.replace({
                query: {
                    url: nodeInfo.documentUrl,
                },
            });
            console.log('叶子节点');
        }
        else {
            console.log('无需异步获取的父节点');
            setIframeUrl('');
        }
    };
    const renderTreeNodes = (data) => data.map(item => {
        if (item.children) {
            return (<TreeNode title={item.title} key={item.key} dataRef={item}>
            {renderTreeNodes(item.children)}
          </TreeNode>);
        }
        return <TreeNode key={item.key} {...item} dataRef={item}/>;
    });
    return (<Root className={className} style={style}>
      <Row>
        <Col span={6}>
          <Card title="帮助中心文档目录" className="tree-card">
            <DirectoryTree loadData={onLoadData} onSelect={handleOnSelect}>
              {renderTreeNodes(data)}
            </DirectoryTree>
          </Card>
        </Col>
        <Col span={18}>
          <Card className="card-iframe">
            {iframeUrl ? (<iframe src={`${iframeUrl}?view=doc_embed`} frameBorder="0" style={{ height: '100%', width: '100%' }}/>) : (<h3>请在左侧选择所需查看的文档</h3>)}
          </Card>
        </Col>
      </Row>
    </Root>);
};
export default HelpDoc;
